import { render, staticRenderFns } from "./CarrierTaxDeleteButton.vue?vue&type=template&id=48db1256&scoped=true&"
import script from "./CarrierTaxDeleteButton.vue?vue&type=script&lang=js&"
export * from "./CarrierTaxDeleteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48db1256",
  null
  
)

export default component.exports